<template>
  <div>
    <CHeader class="bg-dark fixed-top d-flex justify-content-between">
      <CToggler in-header class="d-lg-none" @click="$store.commit('toggleSidebarMobile')">
        <i class="bi bi-list h3 text-white"></i>
      </CToggler>
      <CToggler in-header class="d-md-down-none" @click="$store.commit('toggleSidebarDesktop')">
        <i class="bi bi-list h3 text-white"></i>
      </CToggler>

      <CHeaderNav>
        <!-- <CHeaderNavLink href="https://www.eltiempo.com" class="mr-2" target="_blank">
          <BCIcon name="clone" type="coreui" class="text-white header-nav-icon" style="font-size: 20px" />
        </CHeaderNavLink> -->

        <span class="mx-4" v-if="userData.TRM">TRM:&nbsp;<strong>${{ formatter.format(userData.TRM) }}</strong></span>
        <CHeaderNavLink href="/" class="mr-2" target="_blank" v-c-tooltip="'Abrir una nueva venta'">
          <BCIcon name="window-stack" class="text-white header-nav-icon" style="font-size: 20px" />
        </CHeaderNavLink>
        <a v-if="userData.tipo_Usuario==='E'" href="#" class="mr-2" style="text-decoration: none; right: 3rem" @click="(e) => openRightSideBar(e)">
          <BCIcon name="calendar-check" class="text-white header-nav-icon" style="font-size: 20px" />
        </a>
        <CHeaderNavItem>
          <CDropdown 
            inNav 
            class="c-header-nav-items" 
            placement="bottom-end" 
            add-menu-classes="pt-0 notifications"
            :flip="true" 
            v-if="userData.tipo_Usuario === 'E'">
            <template #toggler>
              <CHeaderNavLink>
                <a href="#" style="text-decoration: none" class="mr-2 position-relative">
                  <BCIcon name="bell" class="text-white header-nav-icon" style="font-size: 20px" />
                  <CBadge color="danger">{{ tracking_notifications_count }}</CBadge>
                </a>
              </CHeaderNavLink>
            </template>
            <CDropdownHeader tag="div" class="d-flex p-3" color="light">
              <h4>Notificaciones</h4>
              <CBadge color="info" class="p-1 ml-2 mt-1 mb-2">{{ tracking_notifications_count }} Nuevos</CBadge>
            </CDropdownHeader>
            <template v-for="tracking_item in tracking_notifications">
              <div class="d-flex mt-2" :key="tracking_item.id_Seguimiento">
                <div class="flex-shrink-1 text-center">
                  <BCIcon class="mx-3" name="alarm" />
                </div>
                <div class="w-100">
                  <strong>{{ tracking_item.clase_Seguimiento }}</strong>
                  <div>
                    {{ tracking_item.comentarios }}
                  </div>
                  <p class="text-muted d-flex mt-3">
                    <span class="mr-2">
                      <BCIcon name="clock" />
                    </span>
                    <span> {{ moment(tracking_item.fecha_Hora).fromNow() }}</span>
                  </p>
                </div>
                <div class="flex-shrink-1 text-center">
                  <CSwitch class="align-middle mx-2" color="dark" shape="pill" size="sm"
                    :checked="tracking_item.estado === 'A'" 
                    @update:checked="
                      (value) => {
                        updateTrackingNotification(tracking_item, value);
                        item.estado = value ? 'A' : 'I';
                      }
                    " />
                </div>
              </div>
            </template>
            <CDropdownDivider />
            <CButton 
              color="info" 
              variant="outline" 
              class="d-flex justify-content-between mx-3" 
              @click="(event) => {
                event.stopPropagation();
                $router.push({
                  path: `/empresa/mercadeo/seguimientos`,
                });
              }">
              <BCIcon name="clock-history" />
              <span class="mx-2">Ver todos</span>
            </CButton>
          </CDropdown>
        </CHeaderNavItem>

        <i class="mr-4">&nbsp;</i>

        <CHeaderNavItem class="mx-2" style="right: 2rem">
          <!-- <CHeaderNavLink>
              <CLink class="btn btn-primary" @click="logOut()">Cerrar Sesión <CIcon name="cil-exit-to-app"/></CLink>
          </CHeaderNavLink> -->
          <HeaderDrop :logOut="logOut" :changePassword="openSideBarChangePassword" />
        </CHeaderNavItem>
      </CHeaderNav>
      <CSubheader class="px-3">
        <CBreadcrumbRouter class="border-0 mb-0" />
      </CSubheader>
    </CHeader>

    <right-side-bar :show="showRightSideBar" class="bg-white">
      <vertical-dynamic-form title="Seguimiento" :fields="trackingdocs_fields" />
      <div class="d-flex justify-content-center">
        <CButton color="success" class="mr-2 d-inline-block" @click="saveTracking()"
          :class="isValidForm ? '' : 'disabled'" :disabled="!isValidForm">
          <CIcon name="cil-check-circle" />
          <span class="align-middle mx-2">Guardar</span>
        </CButton>
        <CButton color="danger" variant="outline" class="mr-2 d-inline-block" @click="
          (e) => {
            e.stopPropagation();
            showRightSideBar = false;
          }
        ">
          <CIcon name="cil-x-circle" />
          <span class="align-middle mx-2">Cancelar</span>
        </CButton>
      </div>
    </right-side-bar>

    <right-side-bar :show="showSideBarChangePassword" class="bg-white">
      <vertical-dynamic-form title="Cambio de contraseña" :fields="changePasswordFields" />
      <div class="d-flex justify-content-center">
        <CButton color="success" class="mr-2 d-inline-block" @click="updatePassword()"
          :class="isValidFormChangePassword ? '' : 'disabled'" :disabled="!isValidFormChangePassword">
          <CIcon name="cil-check-circle" />
          <span class="align-middle mx-2">Guardar</span>
        </CButton>
        <CButton color="danger" variant="outline" class="mr-2 d-inline-block" @click="(e) => {
            e.stopPropagation();
            showSideBarChangePassword = false;
          }">
          <CIcon name="cil-x-circle" />
          <span class="align-middle mx-2">Cancelar</span>
        </CButton>
      </div>
    </right-side-bar>

  </div>
</template>

<style scoped>
  .header-nav-icon {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
</style>

<script>
  import moment from "moment";
  import HeaderDrop from "./HeaderDrop";
  import RightSideBar from "./RightSideBar.vue";
  import VerticalDynamicForm from "./VerticalDynamicForm.vue";
  import BCIcon from "./BCIcon.vue";
  import { formatter } from "../../general";
  import constants from "../../constants";
  import {
    cambioClaveUsuario,
    guardarSeguimiento,
    dataListClasesSeguimientos,
    actualizarEstadoSeguimientosPorUsuario,
  } from "../../api";
  import { obtenerSeguimientosUsuario } from "@/apiData";


  moment.locale("es");

export default {
  name: "Header",
  components: {
    HeaderDrop,
    RightSideBar,
    VerticalDynamicForm,
    BCIcon,
  },
  props: {
    logOut: Function,
  },
  data() {
    const self = this;
    return {
      now: moment(),
      formatter,
      moment,
      showRightSideBar: null,
      trackingdocs_fields: [
        {
          key: "trackingClass",
          value: "",
          type: "select",
          prepend_content: {
            name: "bookmark-check",
          },
          options: [],
          label: "Clase Seguimiento: ",
          required: true,
        },
        {
          key: "dateTracking",
          value: "",
          type: "date",
          prepend_content: {
            name: "calendar-date",
          },
          label: "Fecha Recordatorio: ",
          required: true,
          custom_validation() {
            return self.now.isSameOrBefore(
              `${self.trackingdocs_fields[1].value}T${self.trackingdocs_fields[2].value}`,
              "minutes"
            );
          },
        },
        {
          key: "timeTracking",
          value: "",
          type: "time",
          prepend_content: {
            name: "clock",
          },
          label: "Hora Recordatorio: ",
          required: true,
          custom_validation() {
            return self.now.isSameOrBefore(
              `${self.trackingdocs_fields[1].value}T${self.trackingdocs_fields[2].value}`,
              "minutes"
            );
          },
        },
        {
          key: "comments",
          value: "",
          type: "textarea",
          prepend_content: {
            name: "chat-square-text",
          },
          label: "Comentarios: ",
          required: true,
        },
      ],
      tracking_notifications: [],
      tracking_notifications_count: 0,
      showSideBarChangePassword: null,
      changePasswordFields: [
        {
          key: "oldPassword",
          value: "",
          type: "password",
          prepend_content: {
            name: "unlock",
          },
          label: "Contraseña Actual:",
          required: true
        },
        {
          key: "newPassword",
          value: "",
          type: "password",
          prepend_content: {
            name: "lock",
          },
          label: "Contraseña Nueva:",
          required: true
        },
        {
          key: "newPasswordConfirm",
          value: "",
          type: "password",
          prepend_content: {
            name: "lock",
          },
          label: "Confirmar Nueva Contraseña:",
          required: true,
          custom_validation() {
            return self.changePasswordFields[2].value.length > 0 && (self.changePasswordFields[1].value === self.changePasswordFields[2].value ? true : false);
          }
        },
      ]
    };
  },
  computed: {
    userData() {
      return this.$store.state.user.data;
    },
    isValidForm() {
      return this.trackingdocs_fields.every((field) => {
        if (field.required) {
          if (field.key === "dateTracking" || field.key === "timeTracking") {
            return this.now.isSameOrBefore(
              `${this.trackingdocs_fields[1].value}T${this.trackingdocs_fields[2].value}`,
              "minutes"
            );
          }
          if (typeof field.value === "string") {
            return field.value.length > 0;
          }
          return field.value > 0;
        }

        return true;
      });
    },
    isValidFormChangePassword() {
      return this.changePasswordFields.every((field) => {
        if (field.required) {
          if (field.key === "newPasswordConfirm") {
            return (this.changePasswordFields[1].value === this.changePasswordFields[2].value ? true : false);
          }
          if (typeof field.value === "string") {
            return field.value.length > 0
          }
          return field.value > 0
        }

        return true;
      })
    }
  },
  methods: {
    openRightSideBar(e) {
      e.stopPropagation();
      this.showRightSideBar = true;
      this.now = moment();
      // this.trackingdocs_fields[1].value = this.now.format('YYYY-MM-DD')
      // this.trackingdocs_fields[2].value = this.now.format('HH:mm')
      this.trackingdocs_fields[1].value = "";
      this.trackingdocs_fields[2].value = "";
      this.trackingdocs_fields[0].value = "";
      this.trackingdocs_fields[3].value = "";
    },
    openSideBarChangePassword(){
      // e.stopPropagation();
      this.showSideBarChangePassword = true;
      this.changePasswordFields[0].value = "";
      this.changePasswordFields[1].value = "";
      this.changePasswordFields[2].value = "";
    },
    async saveTracking() {
      this.loading = true;
      try {
        await guardarSeguimiento(
          this,
          this.trackingdocs_fields[0].value,
          this.trackingdocs_fields[1].value,
          this.trackingdocs_fields[2].value,
          this.trackingdocs_fields[3].value,
          null,
          null,
          null,
          null,
          null,
          null,
          true
        );

        this.$store.commit("setAlert", {
          color: "success",
          message: "Acción exitosa",
          show: 5,
        });

        this.showRightSideBar = false;
      } catch (error) {
        console.log(error);
        this.$store.commit("setAlert", {
          color: "danger",
          message: constants.messages.notDoneAdd,
          show: 5,
        });
      } finally {
        this.loading = false;
      }
    },
    async getTrackingClasses() {
      try {
        const response = await dataListClasesSeguimientos(this);
        this.trackingdocs_fields[0].options = [
          {
            value: "",
            label: "Seleccionar",
          },
          ...response.map((item) => {
            return { value: item.id_ClaseSeguimiento, label: item.descripcion };
          }),
        ];
      } catch (error) {
        console.log(error);
      }
    },
    async getTrackingNotifications() {
      try {
        const { response } = await obtenerSeguimientosUsuario(
          this,
          this.$store.state.user.data.id_Empleado
        );

        console.info(response);

        this.tracking_notifications = response.seguimientos;
        this.tracking_notifications_count = response.cantidad;
      } catch (error) {
        console.log(error);
      }
    },
    async updateTrackingNotification(item, value) {
      try {
        await actualizarEstadoSeguimientosPorUsuario(
          this,
          item.id_Seguimiento,
          value ? "A" : "I"
        );
      } catch (error) {
        console.log(error);
      }
    },
    async updatePassword() {
      this.loading = true;
      try {
        await cambioClaveUsuario(
          this,
          this.changePasswordFields[0].value,
          this.changePasswordFields[1].value
        );

        this.$store.commit("setAlert", {
          color: "success",
          message: constants.messages.successfulAction,
          show: 5,
        });

        this.showSideBarChangePassword = false;
      } catch (error) {
        console.log(error);
        this.$store.commit("setAlert", {
          color: "danger",
          message: constants.messages.failedAction,
          show: 5,
        });

        this.showSideBarChangePassword = false;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getTrackingClasses();
    // this.getTrackingNotifications();

    // setInterval(() => {
    //   this.getTrackingNotifications();
    // }, 60000);
  },
};
</script>